import React, { forwardRef, useState } from 'react';
import {
  TextField, Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide,
  FormControl, Select, MenuItem, InputLabel
} from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { useAuth } from '../../customContextProviders/AuthContext';
import { APP_CONSTANTS } from '../../../URLConstants';


/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
/* eslint-enable */


export default function ExportDataFilterModal({ openDateRangeModal, handleClose, actionData, onAction }) {

  const { organizationAudioCubeTerritories } = useAuth()
  const [organizationSelectedZone, setOrganizationSelectedZone] = useState("")
  const [rentStatusVal,setRentStatusVal]=useState("")

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);


  const handleOrganizatioZoneValChange = (event) => {
    setOrganizationSelectedZone(event.target.value)
  }

  const handleRentStatusValChange = (event) => {
    setRentStatusVal(event.target.value)
  }

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };


  return (
    <Dialog
      open={openDateRangeModal}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="date-range-dialog-slide-description"
      data-testid='export-data-modal'
    >
      <DialogTitle>Select Date range</DialogTitle>
      <DialogContent>
        <DialogContentText id="date-range-dialog-slide-description">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid container spacing={3} direction={{xs: 'column', sm: 'row', md: 'row'}}>

              <Grid item xs={6} >
                {
                  organizationAudioCubeTerritories !== undefined && organizationAudioCubeTerritories !== null ?
                    <FormControl size="large" fullWidth>
                      <InputLabel id="device-select-label">Zone </InputLabel>
                      <Select
                        labelId="device-select-label"
                        id="device-select"
                        value={organizationSelectedZone}
                        onChange={handleOrganizatioZoneValChange}
                        label="Zone">
                        <MenuItem value="">ALL</MenuItem>
                        {
                          organizationAudioCubeTerritories?.filter(obj => obj?.parent_id === "0")?.map((row) => (
                            <MenuItem key={row?.name} value={row?.name} sx={{ p: 1.5 }}>{row?.name}</MenuItem>
                          ))
                        }
                      </Select>
                    </FormControl>
                    :
                    null
                }
              </Grid>

              {
                actionData===APP_CONSTANTS?.RENT_STATUS_EXPORT_REPORT ?

                <Grid item xs={6}>
                <FormControl size="large" fullWidth>
                  <InputLabel id="rent-status-select-label">Rent Status</InputLabel>
                  <Select
                    labelId="rent-status-select-label"
                    id="rent-status-select"
                    value={rentStatusVal}
                    onChange={handleRentStatusValChange}
                    label="Rent Status">
                    <MenuItem value="ALL">ALL</MenuItem>
                    <MenuItem value="YES" sx={{ p: 1.5 }}>Yes</MenuItem>
                    <MenuItem value="NO" sx={{ p: 1.5 }}>No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              :
              null

              }



              <Grid item xs={6} >
                {/* <Typography variant="subtitle1" sx={{ mb: 1 }}>Start Date </Typography> */}
                <FormControl size="large" fullWidth>
                <DatePicker
                  openTo="day"
                  views={['year', 'month', 'day']}
                  value={startDate}
                  labelId="start-date-select-label"
                  id="start-date-input"
                  label="Start Date"
                  onChange={handleStartDateChange}
                  maxDate={new Date()}
                  renderInput={(params) => <TextField  placeholder='Start Date' {...params} />}
                  format="DD-MM-YYYY"
                  data-testid='start-date'

                />

                </FormControl>
              </Grid>
              <Grid item xs={6}>
                {/* <Typography variant="subtitle1" sx={{ mb: 1 }}>End Date </Typography> */}
                <FormControl size="large" fullWidth>
                <DatePicker
                  openTo="day"
                  views={['year', 'month', 'day']}
                  value={endDate}
                  label="End Date"
                  maxDate={new Date()}
                  minDate={startDate}
                  onChange={handleEndDateChange}
                  renderInput={(params) => <TextField placeholder='End Date'  {...params} />}
                  data-testid='end-date'

                />
                </FormControl>
              </Grid>
            </Grid>
          </LocalizationProvider>

        </DialogContentText>
      </DialogContent>
      <DialogActions>

        <Button data-testid='export-ok-button' variant='outlined' onClick={() => { onAction
        (
          {
              "startDate":startDate,
              "endDate":endDate,
              "zone":organizationSelectedZone==="" ? null : organizationSelectedZone,
              "rentStatus":rentStatusVal==="" ? null : rentStatusVal,
              "actionData":actionData
          }
          ); handleClose() }}>OK</Button>
      </DialogActions>
    </Dialog>
  );
}

